import { render, staticRenderFns } from "./C-3-1a-4__ProductInfoEdit_Product Spec.vue?vue&type=template&id=a1710bb6&scoped=true&"
import script from "./C-3-1a-4__ProductInfoEdit_Product Spec.vue?vue&type=script&lang=js&"
export * from "./C-3-1a-4__ProductInfoEdit_Product Spec.vue?vue&type=script&lang=js&"
import style0 from "./C-3-1a-4__ProductInfoEdit_Product Spec.vue?vue&type=style&index=0&id=a1710bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1710bb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VIcon,VTextarea})
